import http from "../http-common";
import { getToken } from "../utils/Utils";

const getAll = async () => {
    try {
        return await http.get("/customers", {
            headers: {
                Authorization: `Bearer ${getToken()}`, 
            },
        });
    } catch (error) {
        console.error("Error fetching customers:", error);
        throw error;
    }
};

const get = async (id) => {
    try {
        return await http.get(`/customers/${id}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
    } catch (error) {
        console.error("Error fetching customer by ID:", error);
        throw error;
    }
};

const create = async (data) => {
    try {
        return await http.post(`/customers`, data, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
    } catch (error) {
        console.error("Error creating customer:", error);
        throw error;
    }
};

const update = async (id, data) => {
    try {
        return await http.put(`/customers/${id}`, data, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
    } catch (error) {
        console.error("Error updating customer:", error);
        throw error;
    }
};

const remove = async (id) => {
    try {
        return await http.delete(`/customers/${id}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        });
    } catch (error) {
        console.error("Error deleting customer:", error);
        throw error;
    }
};

const CustomerService = {
    getAll,
    get,
    create,
    update,
    remove,
};

export default CustomerService;
